import {
	Dialog as AriakitDialog,
	DialogDescription as AriakitDialogDescription,
	DialogDisclosure as AriakitDialogDisclosure,
	DialogDismiss as AriakitDialogDismiss,
	DialogHeading as AriakitDialogHeading,
	DialogProvider as AriakitDialogProvider,
	type DialogDescriptionProps,
	type DialogDismissProps,
	type DialogHeadingProps,
	type DialogProps
} from '@ariakit/react'
import type { CSSProperties, HTMLAttributes } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'
import { Overlay } from '@/components/ui/overlay'
import { cn } from '@/helpers/utils'

export const DialogProvider = AriakitDialogProvider
export const DialogDisclosure = AriakitDialogDisclosure

export const Dialog = ({
	width,
	className,
	...rest
}: DialogProps & { width?: CSSProperties['width'] }) => (
	<AriakitDialog
		backdrop={<Overlay />}
		className={cn(
			'fixed top-1/2 left-1/2 z-(--z-modal) max-h-[calc(100%-24px)] max-w-[calc(100%-24px)] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl bg-neutral-white text-neutral-900 shadow-lg',
			className
		)}
		portal
		style={{ width }}
		unmountOnHide
		{...rest}
	/>
)

export const DialogDismiss = (props: DialogDismissProps) => (
	<AriakitDialogDismiss
		render={
			<ButtonLegacy
				shape='square'
				size='sm'
				type='button'
				variant='tertiary'
			>
				<XCloseIcon />
			</ButtonLegacy>
		}
		{...props}
	/>
)

export const DialogHeading = ({ className, ...props }: DialogHeadingProps) => (
	<AriakitDialogHeading
		className={cn('font-medium text-neutral-900 text-sm', className)}
		{...props}
	/>
)

export const DialogDescription = ({
	className,
	...props
}: DialogDescriptionProps) => (
	<AriakitDialogDescription className={cn('text-sm', className)} {...props} />
)

export const DialogHeader = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'grid grid-cols-3 items-center border-neutral-300 border-b px-2.5 py-2 text-center',
			className
		)}
		{...props}
	/>
)

export const DialogBody = ({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'flex h-full flex-col gap-6 overflow-auto p-6',
			className
		)}
		{...rest}
	/>
)

export const DialogFooter = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={cn(
			'flex justify-between border-neutral-300 border-t px-6 py-4',
			className
		)}
		{...props}
	/>
)
